import { render, staticRenderFns } from "./themeTwoDashboard.vue?vue&type=template&id=ded80e0c"
import script from "./themeTwoDashboard.vue?vue&type=script&lang=js"
export * from "./themeTwoDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports